import React, { useEffect, useState } from 'react'
import '../pages/Dashboard/Dashboard.scss'

const DEMOS = {
    'Demo': "https://app.powerbi.com/view?r=eyJrIjoiNGFjYmY5YTItNjQxOC00M2IzLWE5OGItMGEzNzdlMWYwYWZkIiwidCI6IjljNTBhNTYwLTE0OGQtNDE3NC05MDkwLTljYjhkZGZjNzIyYiIsImMiOjl9",
}

const Demo = ({reportSlug, bookmarkSlug}) => {
    // check orgpicker to default to seo
  return (
    <div style={{position: 'relative', height: "100vh"}}>
    {/* <div className="bookmark-toolbar">
      <button className='capture-bookmark' onClick={() => alert("Capture feature is not available on Demo reports")}>Capture</button>
      <button className='give-feedback' onClick={() => window.location.assign("https://test.com")}>Feedback</button>
    </div> */}
    
    <div className="demo">
      <iframe src={DEMOS[reportSlug  || 'Spend']} frameBorder="0" scrolling="no" allowFullScreen={true} width="100%" height="100%"></iframe>
    </div>
    </div>
  )
}

export default React.memo(Demo)
